import {
  FETCH_APPOINTMENTS,
} from './AppointmentsActions'

const INITIAL_STATE = {
  items: [],
  meta: {},
  laundries: [],
  streetAttendants: [],
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_APPOINTMENTS.SUCCESS:
      return {
        ...state,
        items: action.payload.data.data,
        meta: action.payload.data.meta,
        laundries: action.payload.data.laundries,
        streetAttendants: action.payload.data.streetAttendants,
      }
    default:
      return state
  }
}
